/* Author：tanyaohua 2020-08-06
    discription: 全局消息 右下角弹框
    使用方式：
    html:能复用就复用，不能复用就在此目录新增。
    js:核心代码：publicToolService.createWindow('./components/service/noticeWindowTip/noticeWindowTip.html', datas, false);
    新建一个右下角弹框提醒，传入false 将会吧datas传入到弹框中显示。
*/
'use strict';
angular.module('noticeWindowServiceModule', ['noticeWindowModule'])
    .factory('noticeWindowService', ['$q', 'trsHttpService', 'publicToolService', '$filter', '$sessionStorage', '$state', 'modalDialog', 'permissionService', function ($q, trsHttpService, publicToolService, $filter, $sessionStorage, $state, modalDialog, permissionService) {
        return {

            /**
             * [userInfo description]用于获取新闻日历的弹框服务
             *
             * @param   {[type]}  userInfo  [userInfo description]
             *
             * @return  {[type]}            [return description]
             */
            getNewsDailyInfo: function (userInfo) {
                var deffer = $q.defer();
                var now = $filter('date')(new Date(), 'yyyy-MM-dd') ? $filter('date')(new Date(), 'yyyy-MM-dd').toString() : '';
                var nowTime = $filter('date')(new Date(), 'MM月dd日') ? $filter('date')(new Date(), 'MM月dd日').toString() : '';
                var params = {
                    pageNum: 1,
                    pageSize: 100,
                    // selectDate: '2020-08-01', // 测试数据 后期换成下面这个
                    selectDate: now,
                    tenantId: userInfo.TENANTID,
                    userId: userInfo.ID,
                    type: 4,
                };
                trsHttpService.httpServer('/message/daily/list', params, 'get').then(
                    function (data) {
                        if (data.code === '200' && data.datas.length) {
                            var datas = {
                            // 左上角标题定制
                                title: nowTime + ' 新闻日历提醒',
                                // 内容
                                list: data.datas,
                                // 右下角按钮名称
                                btnName: '我知道了',
                                // 自动隐藏时间
                                hiddenTime: 5000,
                            };
                            publicToolService.createWindow('./components/service/noticeWindowTip/noticeWindowTip.html', datas, false);
                            // 设置一个全局的标识
                            $sessionStorage.set('global.strongWindowNewsDailyInfo', 'showed');
                            deffer.resolve();
                        } else {
                            deffer.reject();
                        }
                    },
                    function () {
                        deffer.reject();
                    }
                );
                return deffer.promise;
            },

            /**
             * [params description]用于校验账号有效期 是否过期
             *
             * @param   {[type]}  MediaType  [MediaType description]
             * @param   {[type]}  channel  [tranch description]
             *
             * @return  {[type]}          [return description]
             */
            getAccountValidityInfo: function (MediaType, channel) {
                var defer = $q.defer();
                var params = {
                    MediaType: MediaType,
                    methodname: 'checkAccountValidity',
                    serviceid: 'zmy_product',
                    // productId: channel.ACCOUNTID,
                };
                // 做个兼容
                if (channel) {
                    params.productId = channel.ACCOUNTID || channel.DOUYINACCOUNTID || channel.CHANNELID;
                } else {
                    params.productId = $state.params.accountid || $state.params.account || $state.params.wbchannelid;
                }
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(
                    function (data) {
                        if (channel) {
                            if (data.TYPE === '3' || data.TYPE === '2') { 
                                publicToolService.createWindow('./components/service/noticeWindowTip/accountValidity.html', data);
                            }
                            defer.reject();
                        } else {
                            if (data.TYPE === '3') {
                                modalDialog.alertType('您的账号已经过期，无法发布，是否重新绑定', '', 'ask', true, function(){
                                    // 这是确定回调
                                    window.open(data.URL);
                                    defer.reject();
                                
                                }, function(){
                                    // 这是取消回调
                                    defer.reject();
                                }, '', '取消', '确定');
                            
                                // defer.resolve(data);
                            } else {
                                defer.resolve(data);
                            }
                        }
                    },
                    function () {
                        defer.reject();
                    }
                );
                return defer.promise;
            },

            /**
             * [userInfo description]用于获取提醒的弹框服务
             *
             * @param   {[type]}  userInfo  [userInfo description]
             *
             * @return  {[type]}            [return description]
             */
            sendNoticeOnlogin: function (userInfo) {
                var deffer = $q.defer();
                permissionService.isAdministrator(true).then(function (data) {
                    // 是否是超管
                    let isAdministrator = data;
                    permissionService.isTenantAdministrator(true).then(function (data1) {
                        // 是否是租户管理员
                        let isTenantAdministrator = data1;
                        var params = {
                            admin: isAdministrator,
                            tenantadmin: isTenantAdministrator,
                            tenantid: userInfo.TENANTID,
                            userid: userInfo.ID,
                            truename: userInfo.TRUENAME,
                            username: userInfo.USERNAME,
                        };
                        trsHttpService.httpServer('/message/notice/sendNoticeOnLogin', params, 'get').then(
                            function (data) {
                                // 设置一个全局的标识
                                $sessionStorage.set('global.sendNoticeOnlogin', 'showed');
                                deffer.resolve();
                            },
                            function () {
                                deffer.reject();
                            }
                        );
                    });
                });
                return deffer.promise;
            },
        };
    }]);
